export default __webpack_public_path__ + "static/media/ic-snow.f97a7940.svg";